<template>
  <div>
    <!-- Footer Start -->
    <div class="flex-grow-1">
      <div class="app-footer" style="background-color: #FFFFFF; box-shadow: 3px 3px red, -1em 0 0.4em lightgray;">
        <div class="row">
          <div class="col-12" style="margin-left: 120px;">
               Version {{version}} <span>&copy</span> {{ new Date().getFullYear() }}
          </div>
        </div>          
      </div>
      <!-- Footer End -->
    </div>
  </div>
</template>

<script>
import { global } from "@/global";

export default {
  name: "Footer",
  components: {},
  data() {
    return {
      version: global.app_version
    };
  },
};
</script>

<style></style>
